
  import wordsCounter from 'word-counting';

  export default {
    props: {
      article: { type: Object, required: true }
    },
    data () {
      return { timeToRead: null };
    },
    mounted () {
      this.timeToRead = Math.round(wordsCounter(this.article.body, { isHtml: true }).wordsCount / 200);
    }
  };
